/**
 * @desc es创建加油站索引
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: QueryParams): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/task/createPetrolIndex',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
